import {
    VenueAnalysisVenueTypeData,
    VenueAnalysisVenueData,
} from '../venueAnalysisAggregatedData';
import { getVenueTypeSortOrdinal, VenueType } from 'utils/venueTypeUtils';
import { HighlightedVenue } from 'widgets/venueAnalysis/highlighting';

export interface VenueAnalysisVenueDisplayData extends VenueAnalysisVenueData {
    barWidth: number;
    venues?: VenueAnalysisVenueData[];
    highlightItem?: HighlightedVenue;
}

export function computeBarWidths(
    data: VenueAnalysisVenueTypeData[] | VenueAnalysisVenueData[]
): VenueAnalysisVenueDisplayData[] {
    return (
        data as Array<VenueAnalysisVenueTypeData | VenueAnalysisVenueData>
    ).map((d) => {
        return {
            ...d,
            barWidth: d.percent,
            micCode: (d as VenueAnalysisVenueData).micCode ?? d.name,
        };
    });
}

export function getSortedVenueTypes(
    data?: VenueAnalysisVenueTypeData[]
): VenueAnalysisVenueTypeData[] {
    if (!data) {
        return [];
    }
    const sortedData = data.sort(
        (a, b) =>
            getVenueTypeSortOrdinal(a.name as VenueType) -
            getVenueTypeSortOrdinal(b.name as VenueType)
    );
    return sortedData.filter((d) => !!d);
}

export function filterByVenueType(
    data: VenueAnalysisVenueDisplayData[],
    type: string
) {
    const ret = data.filter((venueType) => venueType.name === type);
    if (ret.length > 0) {
        ret[0].barWidth = 100;
    }
    return ret;
}

export function filterByVenue(
    data: VenueAnalysisVenueDisplayData[],
    venueName: string
) {
    return data.map((d) => ({
        ...d,
        venues: d.venues?.filter((v) => v.name === venueName),
    }));
}
